module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-7e20e2eb56d74029cbae1aebb49dc8cf.svg";